import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { PagerService } from 'app/shared/services/pager.service';
import { SyncDataService } from './../../services/sync-data.service';
import { ISyncDataExportFile } from 'app/core/typings/ISyncDataExportFile';
import { DateUtil } from 'app/core/utils/DateUtil';

@Component({
  selector: 'biz-export-history-table',
  templateUrl: './export-history-table.component.html',
  styleUrls: ['./export-history-table.component.scss']
})
export class ExportHistoryTableComponent implements OnInit {

  public pageSize = 5;
  public currentPage: number;
  public historyPaginated: Array<any> = [];
  public _history: ISyncDataExportFile[];
  @ViewChild("fileLink", { static: false }) fileLink: ElementRef;

  constructor(private _pagerService: PagerService,
    private ref: ChangeDetectorRef, private _syncDataService: SyncDataService) {
    this._history = [];
  }

  ngOnInit() {
  }

  @Input() public set history(history: ISyncDataExportFile[]) {
    if (history && history.length > 0) {
      this._history = history;
      const begin = !this.currentPage ? 0 : this.currentPage;
      const end = begin ? begin + 1 : 1;
      this.historyPaginated = this._history.slice(this.pageSize * begin, this.pageSize * end);
      this.ref.detectChanges();
    }
  }

  onDownloadFile(partitionKey: string, rowKey: string, fileName: string) {
    this._syncDataService.getFileFromTableStorage(partitionKey, rowKey).then(data => {
      let file = new Blob([data], { type: "application/octet-stream" });
      this.fileLink.nativeElement.href = URL.createObjectURL(file);
      this.fileLink.nativeElement.download = fileName;
      this.fileLink.nativeElement.click();
    });
  }

  onPaginationEvent(event) {
    const pager = this._pagerService.getPager(this._history.length, event.pageIndex + 1, event.pageSize);
    this.historyPaginated = this._history.slice(pager.startIndex, pager.endIndex + 1);
    this.currentPage = event.pageIndex;
  }
}
